import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { KeyUri, config } from "../key";

const Careers = () => {
  const [jobPosts, setJobPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch job posts from the backend API
  useEffect(() => {
    axios
      .get(`${KeyUri.BACKEND_URI}/getAllJobPosts`) 
      .then((response) => {
        setJobPosts(response.data);
        setLoading(false);
      })
      .catch((error) => {
        setError("Failed to fetch job posts.");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading job posts...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  return (
    <div className="max-w-7xl mx-auto mt-10 sm:mt-20 md:mt-[12rem] px-4 sm:px-6 lg:px-8 font-lato mb-20">
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-12 sm:-mt-28 md:mt-10">
        Job Openings
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {jobPosts.map((job) => (
          <div
            key={job._id}
            className="border rounded-2xl shadow-md p-6 bg-white hover:shadow-xl transition duration-300"
          >
            <h2 className="text-2xl font-semibold text-blue-600 mb-2">
              {job.job_title}
            </h2>
            <p className="text-sm text-gray-600 mb-1">
              <span className="font-medium text-gray-800">Location:</span>{" "}
              {job.location}
            </p>
            <p className="text-sm text-gray-600 mb-4">
              <span className="font-medium text-gray-800">Salary:</span> ₹
              {job.salary_range.min} - ₹{job.salary_range.max}
            </p>
            <Link
              to={`/job-details/${job._id}`}
              className="text-sm text-white bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded-full inline-block transition duration-300"
            >
              View Details
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Careers;
